<template>
  <div class="layer-manager">
    <CreateNewLayerView v-if="isEditView" @click="toggleCreateLayerModal" />
    <div v-if="getLayers && getLayers.length > 0" class="layer-manager">
      <SlideYUpTransition group>
        <component
          v-for="layer in getLayers"
          :key="layer.id"
          :is="layer.type"
          :data="layer"
      /></SlideYUpTransition>
    </div>
    <div v-else class="no-content-image">
      <img src="@/assets/dashboard_created.svg" class="image" />
      <p>
        No Layers found. Click on
        <strong>Create Layer</strong> to start visualizing your data.
      </p>
    </div>

    <portal to="app">
      <SlideYUpTransition>
        <CreateNewLayerModal
          v-if="showCreateNewLayerModal"
          @close="toggleCreateLayerModal"
        />
      </SlideYUpTransition>
    </portal>
  </div>
</template>

<script>
import EntityModelCard from "@/components/metrics/views/EntityModelCard";
import ComputedLayerCard from "@/components/metrics/views/ComputedLayerCard";
import CreateNewLayerView from "@/components/metrics/views/CreateNewLayerView";
import CreateNewLayerModal from "@/components/metrics/modals/CreateNewLayerModal";
import { SlideYUpTransition } from "vue2-transitions";

import { mapGetters } from "vuex";

export default {
  props: {
    isEditView: Boolean,
  },
  components: {
    EntityModelCard,
    ComputedLayerCard,
    CreateNewLayerView,
    CreateNewLayerModal,
    SlideYUpTransition,
  },
  data() {
    return {
      showCreateNewLayerModal: false,
    };
  },
  computed: {
    ...mapGetters("LayerManager", ["getLayers"]),
  },
  methods: {
    toggleCreateLayerModal() {
      this.showCreateNewLayerModal = !this.showCreateNewLayerModal;
    },
  },
};
</script>

<style lang="scss" scoped>
.layer-manager {
  display: flex;
  flex-direction: column;
}

.no-content-image {
  display: flex;
  flex-direction: column;
  padding: 15px;
  margin-top: 50px;
  justify-content: center;
  align-items: center;

  .image {
    height: 200px;
    width: auto;
  }
  p {
    margin: 0;
    opacity: 0.7;
    margin-top: 20px;
    text-align: center;
  }
}
</style>
